//@flow
import BaseFilter from './base_filter'
import type DataTables from 'datatables.net';

export default class DateRange extends BaseFilter {
    filters: {[string]: [?Date, ?Date]}
    minDate: ?Date
    maxDate: ?Date
    context: (minDate: ?Date, maxDate: ?Date) => void

    constructor(callback: () => void) {
        super(callback);
        this.filters = {}
        this.context = this.call.bind(this);
    }

    call(minDate: ?Date, maxDate: ?Date): void {
        this.minDate = minDate;
        this.maxDate = maxDate;
        this.invoke()
    }

    addFilter(): void {
        return this.setFilter();
    }

    setFilter(): void {
        if (!this.column) throw 'Cannot filter date across all columns';
        this.filters[this.column] = [this.minDate, this.maxDate];
    }

    clearFilter(): void {
        if (this.column) {
            delete this.filters[this.column];
        } else {
            this.filters = {}
        }
    }

    asFunction(): (void | ((settings: any, data: string[], dataIndex: number,
                            columnIndex: {[string]: number}) => boolean)) {
        let filters = this.filters;
        if (Object.keys(filters).length === 0) return undefined;
        return (settings, data: string[], dataIndex: number, columnIndex: {[string]: number}) => {
            return Object.keys(filters).every(column => {
                let [minDate, maxDate] = filters[column];
                let foundDate = new Date(data[columnIndex[column]].substring(0, 10));
                return (minDate || new Date(0)) <= foundDate &&
                        foundDate <= (maxDate || new Date(9999, 1));
            })
        };
    }

    getDescription(): any {
        let keys = Object.keys(this.filters);
        if (keys.length === 0) return {};
        if (keys.length === 1) {
            let [startDate, endDate] = this.filters[keys[0]];
            let result = {};
            if (endDate) {
                endDate.setHours(23,59,59,999);
            }
            if (startDate) result.start_date = startDate.toISOString();
            if (endDate) result.end_date = endDate.toISOString();
            return result;
        } 
        return {dateFilters: this.filters}
    }
}